import TopValidation from '../dist/js/topValidation.js';

/**
 * メインの処理
 * @function topValidation
 * @param {string} zip - 郵便番号
 * @param {string} address01 - 都道府県
 * @param {string} address02 - 住所
 * @returns {TopValidation} - TopValidation クラスのインスタンス
 */
export default function topValidation(zip = 'zip', address01 = 'address01', address02 = 'address02') {
  return new TopValidation({
    zipList: {
      'zip': zip,
      'address01': address01,
      'address02': address02
    }
  });
}
